import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { SpinnerVisibilityService } from 'ng-http-loader';
import Swal from 'sweetalert2'
import { BMApiService } from '../../../services/bm.service';
import { Router } from '@angular/router';
import { UserService } from '../../../services/user.service';
import {
  AngularGridInstance,
  Column,
  FieldType,
  Filters,
  Formatter,
  GridOption,
  FileType,
  Formatters,
  MenuCallbackArgs,

} from 'angular-slickgrid';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { UtilityService } from '../../../services/utility.service';
import { AdminApiService } from '../../../services/admin.service';
import { tranbenchmarkkpi, tranbenchmarkkpihistory, benchmarkkpiposition, kpi, bmoutgoing, bmincomingattendees, bmInOutGoingStatusHistroy } from '../../../models/slakpi';
import { division, department } from '../../../models/admin';
import { formatDate } from '@angular/common';
import { uniqBy } from 'lodash';
import { ToasterService } from '../../../toaster.service';
@Component({
  selector: 'app-bench-mark-outgoing-status',
  templateUrl: './bench-mark-outgoing-status.component.html',
  styleUrls: ['./bench-mark-outgoing-status.component.css']
})
export class BenchMarkOutgoingStatusComponent implements OnInit {
  objBMIncomingAttendees = new bmincomingattendees();
  objBM: any = new bmoutgoing();
  selTab: boolean = true;
  submitted: boolean = false;
  public filterApprovalCount: number = 0;
  columnAtdDefinitions: Column[];
  atdGrid: AngularGridInstance;
  datasetAtd: any;
  invalid: boolean = false;
  public visitor_data: any;
  public organizationType_data: any;  
  public division_data: any;
  public department_data: any;
  public letterStatus_data: any;
  public MDCEOResponse_data: any;
  public LogisticStatus_data: any;
  public VisitStatus_data: any;
  public Delegated_data: any;
  public benchMarkYear_data: any;
  public currentHalf_data: any;
  public gridApi: any;
  public gridColumnApi: any;
  public columnDefs: any;
  public defaultColDef: any;
  public rowData: any;
  public PopoverModule;
  modalRef: BsModalRef;
  @ViewChild('addtemplate', { static: false }) addtemplate: TemplateRef<any>;
  @ViewChild('addAttendeeTemplate', { static: false }) addAttendeeTemplate: TemplateRef<any>;

  @ViewChild('statusUpdateTemplate', { static: false }) statusUpdateTemplate: TemplateRef<any>;
  @ViewChild('statusUpdateHistroyTemplate', { static: false }) statusUpdateHistroyTemplate: TemplateRef<any>; 
  columnDefinitions: Column[];
  gridOptions: GridOption;
  dataset: any;
  yearfilter: any;
  divisionUnofilter: any;
  halffilter: any;
  positionfilter: any;
  angularGrid: AngularGridInstance;
  public BMIncoming_data: any;
  public loading: boolean = true;
  public pageAction: string = 'add';
  isStart: boolean = true;
  public filterDataCollectionCount: number = 0;
  public filterOverdueCount: number = 0;
  public filterCompletedCount: number = 0;
  public filterAll_classactive: string = '';
  public filterDataCollection_classactive: string = 'active';
  public filterOverdue_classactive: string = '';
  public filterCompleted_classactive: string = '';
  public filterApproval_classactive: string = '';
  public tranBenchMarkKPIHistory_data: any;

  objTranBenchmarkKPI: any = new tranbenchmarkkpi();
  //for Users Default Value
  user: any = {};
  login_UserID: string; // number
  isAdmin: boolean;
  statusUno: number = 1;
  position_data: any;

  selectedItem: any;

  surveyDD = [{ id: 1, survey: "survey1" }, { id: 2, survey: "survey2" }, { id: 3, survey: "survey3" }, { id: 4, survey: "survey4" }, { id: 5, survey: "survey5" }];
  btnText: string = 'Add';
    searchText: string;
  dataSearch: any;
  statusDDList = [{ value: 3, text: 'Approved' }, { value: 4, text: 'On Hold' }, { value: 5, text: 'Rejected' }];
  dataHistroy: any;
  bmRequestStatusHistroyDataSet: any[];
  histroyColumnDefinitions: any;
  editID: any;
  yesNoList = [{ value: 1, text: 'Yes' }, { value: 0, text: 'No' }]

  public isBMChampion: boolean = false;
  public isBMTeam: boolean = false;
  public isBMVisitor: boolean = false;
  public isBMAdmin: boolean = false;

  noDataImg: any;
  tenantUno: any;
  constructor(public restApi: BMApiService, public restAdminApi: AdminApiService, private toaster: ToasterService, public utilityService: UtilityService, private router: Router, private spinner: SpinnerVisibilityService, private userService: UserService, private modalService: BsModalService) {
    this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    this.noDataImg = this.utilityService.getnodataImage();
    this.tenantUno = this.user.tenantUno;
    this.ValidateUserAccess();
  }
  //Method used To Validate User Permission

  ValidateUserAccess() {
    

    this.isAdmin = (this.user.role == 'Administrator' || this.user.role == 'BM Administrator') ? true : false;

    if (this.user.role == 'BM Champions')
      this.isBMChampion = true;
    if (this.user.role == 'BM Team')
      this.isBMTeam = true;
    if (this.user.role == 'BM Visitor')
      this.isBMVisitor = true;
    if (this.user.role == 'BM Administrator') { this.isBMAdmin = true; }

    if (!this.isAdmin) {
      let userPermissionData = this.userService.getUserRights("Outgoing Benchmarking Request");
      if (userPermissionData != null && userPermissionData != undefined && userPermissionData.length > 0) {
        if (userPermissionData[0].showPage == 1) {

        }
        else {
          this.router.navigateByUrl('/access-denied');
        }
      }
    }

  }

  ngOnInit() {
    this.userService.CheckLogin();
    this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    this.isAdmin = (this.user.role == 'Administrator') ? true : false;

    this.gridOptions = {
      autoHeight: true,
      enableAutoResize: true,
      enablePagination: true,
      pagination: {
        pageSizes: [5, 10, 20, 50, 100, 500],
        pageSize: 20
      },
      enableFiltering: true,
      alwaysShowVerticalScroll: false,
      enableRowSelection: true,
      autoResize: {
        containerId: 'musherat-grid',
        delay: 0,
        sidePadding: 10,
        bottomPadding: 10
      },
      enableExcelExport: true,
      enableExcelCopyBuffer: true,
      enableFilterTrimWhiteSpace: true,
      showCustomFooter: true, // display some metrics in the bottom custom footer
      enableContextMenu: true,
      enableCellMenu: true,
      forceFitColumns: true,

    };
    
    this.LoadBMOutgoing();
    //this.loadBenckMarkKPIInboxCount();

    this.getVisitorFrom();
    this.getOrganizationType();
    this.getDivisions();
    this.getLetterStatus();
    this.getMDCEOResponse();
    this.getLogisticStatus();
    this.getVisitStatus();
    this.getISDelegated();
    this.getDepartments();
  }

  angularGridReady(angularGrid: AngularGridInstance) {
    this.angularGrid = angularGrid;
    this.userService.angularGrid = angularGrid;
  }
  angularAtdGridReady(angularGrid: AngularGridInstance) {
    this.atdGrid = angularGrid;
    this.userService.angularGrid = angularGrid;
  }
  
  getVisitorFrom() {
    

    this.visitor_data = [
      {text: 'Local', value: 1 },
      { text: 'International', value: 3 },
      
    ];
  }
  getOrganizationType() {
    

    this.organizationType_data = [
      { text: 'Government', value: 1 },
      { text: 'Semi Government', value: 2 },
      { text: 'Private', value: 3 },
      { text: 'Not Applicable', value: 4 },

    ];
  }
  getLetterStatus() {
    this.letterStatus_data = [
      { text: 'Pending', value: 1 },
      { text: 'Completed', value: 2 }
    ];
  }

  getMDCEOResponse() {
    this.MDCEOResponse_data = [
      { text: 'Approve', value: 1 },
      { text: 'Rejecet', value: 2 }
    ];
  }

  getLogisticStatus() {
    this.LogisticStatus_data = [
      { text: 'In Progress', value: 1 },
      { text: 'Pending', value: 2 },
      { text: 'Completed', value: 3 }
    ];
  }
  getVisitStatus() {
    this.VisitStatus_data = [
      { text: 'Conducted', value: 1 },
      { text: 'On Hold', value: 2 },
      { text: 'In Progress', value: 4 },
      { text: 'Not Accepted', value: 3 }
    ];
  }
  getISDelegated() {
    this.Delegated_data = [
      { text: 'Yes', value: 1 },
      { text: 'No', value: 2 }
    ];
  }
  getDivisions() {

    let inpValue = new division();
    inpValue.userUno = this.login_UserID;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 5;
    inpValue.tenantUno = this.tenantUno;
    this.restApi.getDivisions(inpValue)
      .subscribe(data => {

        this.division_data = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }

  getDepartments() {

    let inpValue = new department();
    inpValue.userUno = this.login_UserID;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = 1;
    this.restApi.getDepartments(inpValue)
      .subscribe(data => {

        this.department_data = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }



  

  searchKPIRelease() {
    
    let temp = this;
    this.spinner.show();
    if (!this.isStart) {
      setTimeout(function () { temp.LoadBMOutgoing(); }, 1000)

    }

  }

  openModalWithClass(addtemplate: TemplateRef<any>) {
    this.pageAction = "add";
    this.objBM = new bmoutgoing();
    this.selTab = true;
    this.modalRef = this.modalService.show(
      addtemplate,
      Object.assign({}, {
        class: 'gray modal-lg',
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: true,
        animated: true
      })
    );
  }

  LoadBMOutgoing() {
    

    let inpValue = new bmoutgoing();
    inpValue.id = 1033;
    inpValue.visitTrackUno = 0;
    inpValue.condition = 2;
    inpValue.enteredBy = this.login_UserID.toString();
    inpValue.tenantUno = this.tenantUno;
    this.restApi.getBMOutgoinng(inpValue)
      .subscribe((data: any) => {
        
        let rtn_data = data;
        const mockDataset = [];
        this.dataset = [];
        this.dataSearch = rtn_data;
        if (rtn_data != null && rtn_data.length > 0) {

           //uniqBy(data, 'kpiUno');
          
         
          this.dataset = rtn_data;
          if (rtn_data.length > 0) {
            this.setColnDefn();
          }
          this.BMIncoming_data = rtn_data;
         
          this.isStart = false;
          this.loading = false;
          this.spinner.hide()
        }
        else {
          this.dataset = [];
          this.isStart = false;
          this.loading = false;
          this.spinner.hide()
        }
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }

  searchGrid() {
    
    if (this.searchText != "") {
      this.dataset = this.dataSearch.filter(a =>
        a.division && a.division.toLowerCase().includes(this.searchText.toLowerCase())
        || (a.department && a.department.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.visitFrom && a.visitFrom.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.organizationType && a.organizationType.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.requestStatus && a.requestStatus.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.purposeorSubject && a.purposeorSubject.toLowerCase().includes(this.searchText.toLowerCase())));
    }
    else
      this.dataset = this.dataSearch;
  }
  setColnDefn() {
    let temp = this;
    this.columnDefinitions = [
      {
        id: 'division', name: 'Division', field: 'division', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'division', 'division'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'department', name: 'Department', field: 'department', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'department', 'department'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'visitFrom', name: 'Visitor From', field: 'visitFrom', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'visitFrom', 'visitFrom'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'organizationType', name: 'Organization Type', field: 'organizationType', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'organizationType', 'organizationType'),
          model: Filters.multipleSelect,
        }
      },
      //{
      //  id: 'requestedBy', name: 'Requested By', field: 'requestedBy', sortable: true,
      //  type: FieldType.string, filterable: true,
      //  filter: {
      //    collection: this.uniqueArray(this.dataset, 'requestedBy', 'requestedBy'),
      //    model: Filters.multipleSelect,
      //  }
      //},
      //{
      //  id: 'receivedRequestOn', name: 'Received On', field: 'receivedRequestOn', sortable: true,
      //  type: FieldType.string, filterable: true,
      //  formatter: (row, cell, val, columnDef, dataContext) => {
     
      //      return formatDate(dataContext.receivedRequestOn, 'dd-MM-yyyy', 'en-US');
        
      //  },
       
      //  filter: {
      //    collection: this.uniqueArray(this.dataset, 'receivedRequestOn', 'receivedRequestOn'),
      //    model: Filters.multipleSelect,
      //  }
      //},
      
      {
        id: 'purposeorSubject', name: 'Subject', field: 'purposeorSubject', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'purposeorSubject', 'purposeorSubject'),
          model: Filters.multipleSelect,
        }
      },

      {
        id: 'requestStatus', name: 'Status', field: 'requestStatus', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'requestStatus', 'requestStatus'),
          model: Filters.multipleSelect,
        }
      },
     
     
      
      
      


    ]


  }
  onDbClicked(ev, args) {
    
   //    this.router.navigateByUrl('/benchmarkkpiview/' + rdata.id);
    return false;
  }


  getViewHistory(id: number) {
    

    let inpValue = new tranbenchmarkkpihistory();

    inpValue.itemUno = id;
    inpValue.condition = 1;
    inpValue.userUno = this.login_UserID;
    this.restApi.getTranBenchMarkKPIHistory(inpValue)
      .subscribe(data => {
        
        this.tranBenchMarkKPIHistory_data = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });

  }


  onfilterData(type: any) {
    if (type == 'data')
      this.statusUno = 1;
    if (type == 'approval')
      this.statusUno = 2;
    if (type == 'completed')
      this.statusUno = 5;

    //this.LoadTranBenchmarkKPI();
  }

  actionFormatter: Formatter = (row, cell, value, columnDef, dataContext) => {
    return `<div class="fake-hyperlink"> <i class="fa fa-ellipsis-h fa-lg"></i></div>`;
  };
  uniqueArray(arrayList, val, label) {
    var temp = this;
    var aList = [];
    if (arrayList) {
      for (var i = 0, l = arrayList.length; i < l; i++)
        if (aList.filter(item => item.label == temp.Checklabel(arrayList[i][label])).length == 0) {

          aList.push({
            'value': this.CheckValue(arrayList[i][val]), 'label': this.Checklabel(arrayList[i][label])
          });
        }
    }


    aList.sort((a: any, b: any) => {
      if (a['value'] < b['value']) {
        return -1;
      } else if (a['value'] > b['value']) {
        return 1;
      } else {
        return 0;
      }
    });
    return aList;
  }

  Checklabel(val) {
    if (val != undefined && val != null && val != '' && val != ' ')
      return val;
    else
      return ''

  }

  CheckValue(val) {
    if (val != undefined && val != null && val != '' && val != ':')
      return val;
    else
      return ' '

  }

  IsNull(val) {
    if (val != undefined && val != null && val != '') {
      val = val.trim()
      return val.charAt(0).toUpperCase() + val.slice(1);
    }
    else
      return ' '

  }

  
}
